module.exports = __webpack_public_path__ + "img/w3_pdf_light.9bc5db9d.png";